module.exports = __webpack_public_path__ + "static/media/bg_signup.a58d2c61.png";